module.exports = __webpack_public_path__ + "static/media/asset-2.37c7d2e0.svg";